import type { KonvaEventObject } from 'konva/lib/Node';

export const setStageCursor = (evt: KonvaEventObject<unknown>, cursor: string) => {
  const stageContainer = evt.target.getStage()?.container();
  if (stageContainer) stageContainer.style.cursor = cursor;
};
